import { isListenedEmail } from "@/lib/conversation/listenedEmail";
import { isRecordedMeeting } from "@/lib/conversation/recordedMeeting";
import type { Conversation } from "@/types/conversation/conversation";

/**
 * A phone call a Listener genie recorded on its own number
 * (twilio-webhook/handlers/listener.ts): stored as a recording, but a real
 * customer call with a suggested follow-up for the team.
 */
export const isListenedCall = (conversation: Pick<Conversation, "type" | "metadata">): boolean =>
  isRecordedMeeting(conversation.type) && conversation.metadata?.source === "phone";

/** A call or forwarded email a Listener genie heard: these make up the central inbox's queues. */
export const isListened = (conversation: Pick<Conversation, "type" | "metadata">): boolean =>
  isListenedEmail(conversation.type) || isListenedCall(conversation);
